import { useEffect } from "react";
import { shallowEqual } from "react-redux";
import type { CarConfigDispatchType } from "../redux/store";
import { useCarConfigSelector } from "../redux/store";
import { getFinanceQuoteIdFromStorage, getSessionStorageParams } from "../utils/sessionStorage";
import { startFinanceRateFetch, updateFinanceQuote } from "../redux/slices/CarConfigFinanceSlice";

import { showCarConfigMonthlyRateSelector } from "../utils/selectorUtils";
import { FinanceUpdateTrigger } from "../../../../common-deprecated/features/tradein/utils/tradeInAemUtilTypes";
import { useDispatch } from "../../../../shared-logic/redux/store";

const useAphFinanceInit = (): void => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const sessionStorageParams = useCarConfigSelector(getSessionStorageParams, shallowEqual);
    const financeQuoteId = useCarConfigSelector((state) => state.finance.quotes.finance);
    const car = useCarConfigSelector((state) => state.car);
    const financeEnabled = useCarConfigSelector(showCarConfigMonthlyRateSelector, shallowEqual);

    useEffect(() => {
        if (!financeEnabled) return;

        /**
         * START HACK
         * Would rather not do this but this is necessary for the dash calculator for Lexus switserland.
         * This still uses the financequoteService and for some reason without the FQS flow Checks these remnant properties from the tridion sites.
         */
        if (!window.T1) window.T1 = { settings: {} };
        if (!window.T1.settings) window.T1.settings = {};
        if (!window.T1.settings.finance) {
            window.T1.settings.finance = {
                personalFinanceEnabled: "true",
                personalInsuranceEnabled: "true",
            };
        }
        /**
         * END HACK
         */

        if (!financeQuoteId) {
            const financeSessionQuoteId = getFinanceQuoteIdFromStorage(sessionStorageParams, car.model.id);

            // No quote id in state set the session qoutes id
            if (financeSessionQuoteId) {
                dispatch(updateFinanceQuote({ finance: financeSessionQuoteId, hideNotification: true }));
            } else dispatch(startFinanceRateFetch({ trigger: FinanceUpdateTrigger.Initial }));
        }

        // Should only run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useAphFinanceInit;
